import { render, staticRenderFns } from "./publishRequires.vue?vue&type=template&id=6c2ae7db&scoped=true&"
import script from "./publishRequires.vue?vue&type=script&lang=js&"
export * from "./publishRequires.vue?vue&type=script&lang=js&"
import style0 from "./publishRequires.vue?vue&type=style&index=0&id=6c2ae7db&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2ae7db",
  null
  
)

export default component.exports